module.exports = __webpack_public_path__ + "img/52200.0a67bcd6.jpg";